var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarfield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1673,
    height: 677,
    viewBox: "0 0 1673 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2018)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_2018)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 943.395,
    cy: 107.039,
    r: 1.02144,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.119,
    cy: 321.596,
    r: 1.10548,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.389,
    cy: 432.531,
    r: 0.918346,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1033.37,
    cy: 360.346,
    r: 0.778285,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.98,
    cy: 68.1115,
    r: 1.47434,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.935,
    cy: 164.233,
    r: 1.44536,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.482,
    cy: 136.96,
    r: 1.30452,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.0667,
    cy: 478.723,
    r: 1.07449,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1364.21,
    cy: 117.59,
    r: 1.17348,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.31,
    cy: 312.662,
    r: 1.18268,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.935,
    cy: 41.3231,
    r: 1.11798,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.496,
    cy: 589.818,
    r: 1.4997,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1499.36,
    cy: 577.999,
    r: 0.976729,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.357,
    cy: 352.594,
    r: 1.12118,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.11,
    cy: 439.645,
    r: 0.861022,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.007,
    cy: 388.419,
    r: 1.20264,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 956.394,
    cy: 639.609,
    r: 1.00489,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.25,
    cy: 297.532,
    r: 1.16565,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.6,
    cy: 618.365,
    r: 0.855342,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.829,
    cy: 155.028,
    r: 1.31407,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.395,
    cy: 351.089,
    r: 0.853891,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.811,
    cy: 82.8639,
    r: 1.02581,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705.682,
    cy: 104.451,
    r: 0.823415,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1590.25,
    cy: 75.7848,
    r: 0.862408,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942.164,
    cy: 572.976,
    r: 1.10858,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.051,
    cy: 116.332,
    r: 1.13853,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.698,
    cy: 357.529,
    r: 1.39874,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.922,
    cy: 18.0379,
    r: 1.46076,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.778,
    cy: 143.409,
    r: 1.19,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.437,
    cy: 239.769,
    r: 1.28415,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900.922,
    cy: 82.8954,
    r: 1.11778,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1253.37,
    cy: 590.646,
    r: 1.41895,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.75,
    cy: 65.998,
    r: 1.33882,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1401.75,
    cy: 153.199,
    r: 1.02478,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.385,
    cy: 101.869,
    r: 0.784476,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1319.41,
    cy: 664.565,
    r: 0.830728,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1292.57,
    cy: 271.863,
    r: 1.24501,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 757.166,
    cy: 502.701,
    r: 1.3628,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1377.02,
    cy: 608.512,
    r: 1.16437,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.42,
    cy: 356.552,
    r: 1.46568,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1264.87,
    cy: 116.363,
    r: 1.24221,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 910.414,
    cy: 559.238,
    r: 0.839228,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.454,
    cy: 538.718,
    r: 1.46941,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1074.08,
    cy: 668.612,
    r: 0.868935,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.911,
    cy: 99.5904,
    r: 1.02739,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.089,
    cy: 491.645,
    r: 1.01223,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 957.177,
    cy: 676.923,
    r: 0.758483,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1561.93,
    cy: 487.101,
    r: 0.993197,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.998,
    cy: 534.669,
    r: 1.17144,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1211.68,
    cy: 651.816,
    r: 1.25436,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1560.57,
    cy: 646.879,
    r: 1.31612,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.205,
    cy: 212.323,
    r: 0.920551,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.366,
    cy: 351.162,
    r: 1.3355,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.142,
    cy: 164.098,
    r: 0.815284,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117,
    cy: 235.295,
    r: 1.23651,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1031.91,
    cy: 425.206,
    r: 1.32529,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1450.19,
    cy: 501.72,
    r: 1.22259,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.8005,
    cy: 186.236,
    r: 0.950918,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.33,
    cy: 470.685,
    r: 0.821244,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.04,
    cy: 50.2911,
    r: 0.87098,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.097,
    cy: 115.414,
    r: 0.894126,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.202,
    cy: 557.995,
    r: 1.34814,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.43,
    cy: 532.661,
    r: 0.974471,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.877,
    cy: 404.152,
    r: 1.05341,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.733,
    cy: 662.448,
    r: 0.896651,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170.72,
    cy: 659.994,
    r: 0.991091,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1109.98,
    cy: 595.249,
    r: 1.13554,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.098,
    cy: 648.142,
    r: 0.922693,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722.808,
    cy: 350.19,
    r: 1.25959,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.517,
    cy: 162.398,
    r: 1.44204,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.843,
    cy: 242.695,
    r: 1.21285,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.279,
    cy: 504.512,
    r: 1.48454,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.46,
    cy: 17.484,
    r: 1.45468,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.872,
    cy: 324.071,
    r: 1.17572,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1380.19,
    cy: 305.103,
    r: 1.4985,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.382,
    cy: 669.061,
    r: 0.851164,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.983,
    cy: 534.094,
    r: 1.27013,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1273.81,
    cy: 107.569,
    r: 1.09104,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.852,
    cy: 629.351,
    r: 1.33092,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1440.46,
    cy: 668.62,
    r: 1.0018,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 967.13,
    cy: 54.3279,
    r: 1.31213,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1371.14,
    cy: 416.914,
    r: 0.765222,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.41,
    cy: 529.801,
    r: 1.18018,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.426,
    cy: 514.304,
    r: 1.19539,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.752,
    cy: 671.703,
    r: 1.44704,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.303,
    cy: 282.585,
    r: 1.42701,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1199.7,
    cy: 36.5606,
    r: 0.844304,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.717,
    cy: 23.6447,
    r: 1.03139,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.08,
    cy: 508.164,
    r: 1.38069,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.71,
    cy: 239.238,
    r: 0.959476,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.8,
    cy: 583.218,
    r: 0.768536,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 944.826,
    cy: 532.639,
    r: 0.98771,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629.691,
    cy: 474.847,
    r: 0.947063,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.53,
    cy: 358.747,
    r: 1.32209,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650.591,
    cy: 187.855,
    r: 1.43101,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.441,
    cy: 414.525,
    r: 1.08381,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.06,
    cy: 524.571,
    r: 0.893486,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1062.75,
    cy: 527.159,
    r: 0.841808,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.712,
    cy: 29.1434,
    r: 1.20116,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.387,
    cy: 289.575,
    r: 1.03912,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.076,
    cy: 343.926,
    r: 1.06049,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 733.147,
    cy: 422.29,
    r: 0.938946,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.741,
    cy: 116.755,
    r: 1.32229,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800.62,
    cy: 429.44,
    r: 1.00256,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 999.333,
    cy: 288.946,
    r: 1.33916,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.858,
    cy: 65.5027,
    r: 1.42631,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.968,
    cy: 386.142,
    r: 0.922703,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1467.52,
    cy: 596.404,
    r: 1.02082,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.45,
    cy: 13.6594,
    r: 1.4801,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.47,
    cy: 182.267,
    r: 1.00715,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411.34,
    cy: 4.60904,
    r: 0.858432,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.751,
    cy: 470.467,
    r: 1.48453,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.13,
    cy: 224.103,
    r: 1.17057,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 535.036,
    cy: 141.883,
    r: 1.13789,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.65,
    cy: 304.604,
    r: 1.15753,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.2,
    cy: 360.555,
    r: 1.02518,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1486.2,
    cy: 473.971,
    r: 1.14307,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 681.249,
    cy: 60.4772,
    r: 0.763413,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 932.748,
    cy: 133.273,
    r: 1.4361,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.229,
    cy: 384.895,
    r: 1.22761,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.532,
    cy: 650.064,
    r: 0.93822,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.928,
    cy: 108.372,
    r: 0.884519,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1332.88,
    cy: 453.707,
    r: 1.42454,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1291.24,
    cy: 391.92,
    r: 0.903947,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1569.92,
    cy: 318.848,
    r: 1.07369,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.135,
    cy: 369.856,
    r: 0.817424,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.933,
    cy: 597.759,
    r: 1.40141,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.615,
    cy: 209.091,
    r: 1.34372,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.2465,
    cy: 461.203,
    r: 1.25244,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1360.47,
    cy: 149.945,
    r: 0.911971,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.841,
    cy: 496.01,
    r: 1.39099,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.531,
    cy: 548.688,
    r: 0.86452,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1135.42,
    cy: 217.034,
    r: 1.30704,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927.693,
    cy: 78.4433,
    r: 0.887264,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.189,
    cy: 173.329,
    r: 1.14735,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.924,
    cy: 408.001,
    r: 1.20074,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669.962,
    cy: 578.656,
    r: 1.08676,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1065.77,
    cy: 271.304,
    r: 0.84405,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.653,
    cy: 443.6,
    r: 1.06479,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1529.45,
    cy: 210.342,
    r: 0.943776,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1025.93,
    cy: 411.815,
    r: 1.41612,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.53,
    cy: 360.743,
    r: 0.903586,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.222,
    cy: 285.655,
    r: 1.45369,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.26,
    cy: 582.296,
    r: 1.31251,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1356.91,
    cy: 652.919,
    r: 1.47414,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1488.97,
    cy: 254.963,
    r: 0.952227,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478.7,
    cy: 58.0745,
    r: 1.15985,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1326.17,
    cy: 421.048,
    r: 1.14092,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1341.73,
    cy: 32.8423,
    r: 1.35938,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.646,
    cy: 224.076,
    r: 0.88375,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1464.09,
    cy: 663.538,
    r: 1.13096,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1129.22,
    cy: 664.528,
    r: 0.838334,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1417.58,
    cy: 287.928,
    r: 0.949521,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.222,
    cy: 5.87625,
    r: 1.15994,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881.435,
    cy: 137.685,
    r: 1.35989,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1417.97,
    cy: 391.398,
    r: 1.14607,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1091.71,
    cy: 597.203,
    r: 0.868499,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1454.83,
    cy: 499.236,
    r: 1.06918,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 771.103,
    cy: 32.2573,
    r: 1.09263,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986.703,
    cy: 27.6678,
    r: 1.42675,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.175,
    cy: 482.441,
    r: 1.34462,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 677.372,
    cy: 86.5989,
    r: 1.29569,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 748.951,
    cy: 312.804,
    r: 1.39143,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.237,
    cy: 178.957,
    r: 0.792726,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.311,
    cy: 252.224,
    r: 0.849608,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.965,
    cy: 374.383,
    r: 1.06836,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.366,
    cy: 30.7705,
    r: 1.36991,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 683.808,
    cy: 95.5512,
    r: 1.27242,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1447.04,
    cy: 420.599,
    r: 1.46552,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1353.77,
    cy: 277.567,
    r: 1.47999,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755.817,
    cy: 612.792,
    r: 0.772971,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.176,
    cy: 227.623,
    r: 0.894611,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1482.75,
    cy: 586.416,
    r: 1.42425,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.446,
    cy: 21.9391,
    r: 1.51271,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 867.955,
    cy: 480.202,
    r: 0.86686,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1401.74,
    cy: 443.401,
    r: 1.16743,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.453,
    cy: 411.168,
    r: 0.854154,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.213,
    cy: 376.256,
    r: 1.1276,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.67,
    cy: 658.762,
    r: 0.933111,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.68,
    cy: 387.982,
    r: 1.49948,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.7223,
    cy: 325.54,
    r: 1.17837,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942.798,
    cy: 498.243,
    r: 0.946642,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.813,
    cy: 22.1425,
    r: 1.12577,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 536.785,
    cy: 8.62246,
    r: 1.00723,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.874,
    cy: 572.517,
    r: 0.802385,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1354.48,
    cy: 77.3185,
    r: 1.36492,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.89,
    cy: 644.176,
    r: 1.28689,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.555,
    cy: 358.407,
    r: 1.12428,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1251.36,
    cy: 667.566,
    r: 1.29995,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1404.96,
    cy: 128.129,
    r: 1.23211,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.437,
    cy: 104.419,
    r: 1.41905,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051.88,
    cy: 466.319,
    r: 0.95289,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.213,
    cy: 641.125,
    r: 0.973715,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.541,
    cy: 138.886,
    r: 1.01566,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.555,
    cy: 499.924,
    r: 1.33552,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.58,
    cy: 356.586,
    r: 1.4022,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752.671,
    cy: 297.974,
    r: 1.13056,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.405,
    cy: 225.123,
    r: 1.2794,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.51,
    cy: 280.369,
    r: 0.805675,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.669,
    cy: 44.8184,
    r: 0.828426,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.782,
    cy: 597.023,
    r: 0.92374,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.95,
    cy: 152.83,
    r: 1.22157,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.295,
    cy: 214.418,
    r: 1.09925,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1536.56,
    cy: 97.7148,
    r: 1.0795,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 781.649,
    cy: 510.677,
    r: 1.28254,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.354,
    cy: 300.814,
    r: 1.23702,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1341.08,
    cy: 580.671,
    r: 1.33766,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.9,
    cy: 454.542,
    r: 1.13149,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217.07,
    cy: 136.82,
    r: 0.92862,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1462.25,
    cy: 450.172,
    r: 1.42431,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.848,
    cy: 289.365,
    r: 1.50134,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1462.46,
    cy: 103.438,
    r: 1.25918,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.01,
    cy: 33.6279,
    r: 0.936014,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.0127,
    cy: 511.55,
    r: 0.785146,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587.995,
    cy: 346.031,
    r: 1.25043,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 661.107,
    cy: 666.057,
    r: 1.14718,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618.56,
    cy: 124.215,
    r: 1.38972,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.254,
    cy: 218.077,
    r: 1.26905,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.347,
    cy: 509.388,
    r: 1.25347,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.293,
    cy: 366.275,
    r: 0.819513,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1317.18,
    cy: 318.457,
    r: 1.3382,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.423,
    cy: 430.199,
    r: 0.879069,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1167.42,
    cy: 222.466,
    r: 1.11237,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1177.66,
    cy: 649.715,
    r: 0.859169,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.408,
    cy: 145.179,
    r: 0.962597,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.889,
    cy: 259.089,
    r: 1.14146,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.89,
    cy: 586.574,
    r: 1.12207,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.586,
    cy: 375.774,
    r: 1.40595,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626.416,
    cy: 558.594,
    r: 1.10904,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1427.7,
    cy: 546.149,
    r: 1.11591,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.974,
    cy: 300.281,
    r: 1.45296,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.874,
    cy: 599.821,
    r: 0.805729,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1535.01,
    cy: 380.072,
    r: 1.22143,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1592.64,
    cy: 436.049,
    r: 1.25983,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1378.56,
    cy: 526.493,
    r: 1.28112,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1242.98,
    cy: 572.19,
    r: 0.862951,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.734,
    cy: 268.695,
    r: 1.18728,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1501.68,
    cy: 11.861,
    r: 0.831827,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.625,
    cy: 32.6553,
    r: 1.15672,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1332.21,
    cy: 65.2128,
    r: 0.887921,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1317.77,
    cy: 209.541,
    r: 1.18705,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.032,
    cy: 386.758,
    r: 0.792481,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.56,
    cy: 127.114,
    r: 1.48815,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.618,
    cy: 459.688,
    r: 0.906562,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.03,
    cy: 541.468,
    r: 1.01254,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.408,
    cy: 632.541,
    r: 0.803404,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 957.442,
    cy: 70.8585,
    r: 1.18719,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.806,
    cy: 140.259,
    r: 0.766218,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.741,
    cy: 636.488,
    r: 1.1819,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.862,
    cy: 337.421,
    r: 0.761127,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 725.816,
    cy: 269.512,
    r: 1.10266,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1175.7,
    cy: 239.49,
    r: 1.36334,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.79,
    cy: 608.454,
    r: 1.18407,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.26,
    cy: 588.988,
    r: 1.33948,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 932.412,
    cy: 535.333,
    r: 1.24232,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.319,
    cy: 349.975,
    r: 1.15425,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.474,
    cy: 256.052,
    r: 0.966873,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.97,
    cy: 676.23,
    r: 0.90894,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1389.5,
    cy: 455.178,
    r: 0.909825,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.342,
    cy: 673.825,
    r: 1.131,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390.39,
    cy: 329.451,
    r: 1.46695,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.287,
    cy: 604.986,
    r: 0.765389,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.038,
    cy: 113.159,
    r: 0.951201,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.1982,
    cy: 190.193,
    r: 0.974396,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1501.31,
    cy: 610.819,
    r: 0.835213,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1374.8,
    cy: 527.827,
    r: 0.899034,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1516.91,
    cy: 627.702,
    r: 0.846048,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.469,
    cy: 255.77,
    r: 0.815274,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1110.29,
    cy: 489.133,
    r: 1.27806,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.978,
    cy: 160.626,
    r: 1.06525,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.86,
    cy: 45.4007,
    r: 1.36656,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.47,
    cy: 339.383,
    r: 1.10537,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.645,
    cy: 292.952,
    r: 1.3011,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.699,
    cy: 381.387,
    r: 1.00487,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1516.02,
    cy: 457.857,
    r: 1.08441,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.141,
    cy: 613.331,
    r: 1.09909,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.55,
    cy: 56.2949,
    r: 1.02028,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.696,
    cy: 8.99578,
    r: 0.802662,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1399.46,
    cy: 60.5451,
    r: 0.78339,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.019,
    cy: 372.394,
    r: 0.970231,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.146,
    cy: 82.321,
    r: 1.19555,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.419,
    cy: 492.596,
    r: 1.10813,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1272.69,
    cy: 515.77,
    r: 1.42903,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522.48,
    cy: 495.325,
    r: 1.14901,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 627.695,
    cy: 419.945,
    r: 1.38581,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.318,
    cy: 508.425,
    r: 1.23476,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.836,
    cy: 178.212,
    r: 0.828544,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570.039,
    cy: 29.954,
    r: 1.40008,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.203,
    cy: 657.549,
    r: 0.978029,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.663,
    cy: 372.388,
    r: 1.24417,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1261.08,
    cy: 320.008,
    r: 1.13587,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.875,
    cy: 657.855,
    r: 1.5104,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.556,
    cy: 600.534,
    r: 0.967696,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.282,
    cy: 77.0997,
    r: 0.869979,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.72,
    cy: 276.559,
    r: 0.990076,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.015,
    cy: 322.689,
    r: 1.37229,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.01,
    cy: 44.7384,
    r: 1.48233,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4425,
    cy: 201.957,
    r: 0.837011,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848.18,
    cy: 99.1091,
    r: 1.45501,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.357,
    cy: 663.999,
    r: 1.33997,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.1,
    cy: 577.423,
    r: 0.9551,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.85,
    cy: 55.049,
    r: 1.10579,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.564,
    cy: 271.051,
    r: 1.30311,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 525.067,
    cy: 582.029,
    r: 0.975814,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881.973,
    cy: 677.657,
    r: 0.984969,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.214,
    cy: 38.8167,
    r: 1.34183,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.005,
    cy: 252.896,
    r: 0.956659,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185.5,
    cy: 224.8,
    r: 1.18883,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546.424,
    cy: 284.401,
    r: 0.8282,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 959.858,
    cy: 156.159,
    r: 0.960411,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.64,
    cy: 518.795,
    r: 0.857088,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1350.23,
    cy: 108.895,
    r: 1.30393,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.02,
    cy: 346.188,
    r: 1.05474,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1330.25,
    cy: 240.543,
    r: 1.42806,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.45,
    cy: 168.09,
    r: 1.11751,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.104,
    cy: 499.677,
    r: 1.47087,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1505.23,
    cy: 602.106,
    r: 1.11923,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1570.18,
    cy: 298.258,
    r: 1.35164,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.169,
    cy: 68.1006,
    r: 1.44058,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1518.68,
    cy: 85.5027,
    r: 1.2125,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.792,
    cy: 482.538,
    r: 1.36085,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.879,
    cy: 525.651,
    r: 1.0441,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 985.407,
    cy: 179.553,
    r: 1.11984,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.21,
    cy: 259.951,
    r: 0.810134,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1449.03,
    cy: 35.7927,
    r: 1.40281,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1178.71,
    cy: 210.002,
    r: 1.51181,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.541,
    cy: 225.311,
    r: 1.29053,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 747.589,
    cy: 593.059,
    r: 1.47418,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.185,
    cy: 578.556,
    r: 1.31969,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.423,
    cy: 330.67,
    r: 0.83856,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1064.89,
    cy: 237.51,
    r: 1.16413,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.793,
    cy: 80.9729,
    r: 1.33802,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.782,
    cy: 190.337,
    r: 0.806937,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.197,
    cy: 14.0999,
    r: 0.895786,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1289.47,
    cy: 622.316,
    r: 1.34901,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1564.3,
    cy: 94.1195,
    r: 1.41811,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1308.68,
    cy: 228.313,
    r: 0.835659,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1564.99,
    cy: 38.588,
    r: 1.49025,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.963,
    cy: 403.854,
    r: 1.30959,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7306,
    cy: 168.12,
    r: 1.03432,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.7444,
    cy: 236.328,
    r: 0.886251,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.236,
    cy: 217.49,
    r: 0.760938,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1506.03,
    cy: 445.861,
    r: 1.18526,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1221.66,
    cy: 33.3287,
    r: 1.15623,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1292.03,
    cy: 372.569,
    r: 1.2685,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.44,
    cy: 2.79752,
    r: 1.2305,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1494.04,
    cy: 608.385,
    r: 1.11475,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.872,
    cy: 625.024,
    r: 1.45749,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.651,
    cy: 570.654,
    r: 0.780842,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478.44,
    cy: 17.0811,
    r: 0.897512,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770.421,
    cy: 504.88,
    r: 1.49592,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.53,
    cy: 556.619,
    r: 0.807013,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.173,
    cy: 239.51,
    r: 1.44361,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 702.973,
    cy: 192.387,
    r: 0.787117,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.423,
    cy: 639.565,
    r: 1.36747,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 596.817,
    cy: 255.569,
    r: 0.776953,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.449,
    cy: 377.021,
    r: 0.976347,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.601,
    cy: 454.103,
    r: 0.927992,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.94,
    cy: 595.834,
    r: 1.03127,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.624,
    cy: 1.81013,
    r: 1.0146,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1223.36,
    cy: 596.23,
    r: 1.44117,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.267,
    cy: 15.434,
    r: 1.33948,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1228.44,
    cy: 292.438,
    r: 1.02681,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726.986,
    cy: 254.047,
    r: 1.33147,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755.524,
    cy: 670.185,
    r: 1.49834,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1236.71,
    cy: 499.413,
    r: 0.905726,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1534.56,
    cy: 634.406,
    r: 1.43108,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.245,
    cy: 535.789,
    r: 0.769351,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1538.58,
    cy: 311.574,
    r: 1.14861,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036.56,
    cy: 544.561,
    r: 1.23111,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.715,
    cy: 353.505,
    r: 1.20745,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.933,
    cy: 490.59,
    r: 0.940285,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.069,
    cy: 232.935,
    r: 1.38173,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.175,
    cy: 298.563,
    r: 1.27417,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1420.37,
    cy: 634.965,
    r: 0.776659,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.713,
    cy: 52.2943,
    r: 1.07919,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709.673,
    cy: 482.099,
    r: 0.820153,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.88,
    cy: 37.9968,
    r: 0.817567,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.62,
    cy: 542.696,
    r: 0.940095,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051.89,
    cy: 652.241,
    r: 1.18607,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1188.05,
    cy: 554.43,
    r: 0.878815,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1361.27,
    cy: 589.837,
    r: 1.13334,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.078,
    cy: 627.316,
    r: 1.05017,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.684,
    cy: 350.891,
    r: 1.24577,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 973.229,
    cy: 508.143,
    r: 1.30934,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.66,
    cy: 547.305,
    r: 1.22588,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1332.29,
    cy: 142.281,
    r: 0.901213,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1381.98,
    cy: 244.815,
    r: 1.4103,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1445.55,
    cy: 417.456,
    r: 1.08214,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1155.62,
    cy: 194.495,
    r: 1.06619,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.017,
    cy: 319.743,
    r: 0.925561,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.357,
    cy: 42.2724,
    r: 1.14568,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.31,
    cy: 402.304,
    r: 1.10331,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305.83,
    cy: 2.12702,
    r: 1.29657,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1329.66,
    cy: 102.08,
    r: 1.37864,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.171,
    cy: 229.418,
    r: 0.835879,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1272.07,
    cy: 431.369,
    r: 1.21083,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.21,
    cy: 507.674,
    r: 1.40401,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.151,
    cy: 301.644,
    r: 0.954769,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.698,
    cy: 6.79508,
    r: 1.34269,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.046,
    cy: 450.371,
    r: 0.968275,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1273.03,
    cy: 598.708,
    r: 1.22093,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1098.12,
    cy: 663.31,
    r: 1.16793,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.062,
    cy: 274.499,
    r: 1.20813,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.021,
    cy: 276.507,
    r: 1.42019,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.319,
    cy: 449.226,
    r: 1.17005,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.718,
    cy: 108.055,
    r: 1.37603,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1412.11,
    cy: 412.694,
    r: 0.86409,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1439.06,
    cy: 509.316,
    r: 1.30757,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.679,
    cy: 591.58,
    r: 1.14507,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731.138,
    cy: 611.845,
    r: 1.01231,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 953.222,
    cy: 606.399,
    r: 0.973042,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.19,
    cy: 257.531,
    r: 0.981504,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.44,
    cy: 419.383,
    r: 1.47165,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 695.276,
    cy: 476.763,
    r: 1.17406,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.776,
    cy: 526.622,
    r: 1.36735,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690.024,
    cy: 254.091,
    r: 1.42974,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1362.82,
    cy: 169.552,
    r: 1.43021,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.713,
    cy: 633.764,
    r: 1.18045,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988.457,
    cy: 253.119,
    r: 0.998521,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.841,
    cy: 543.516,
    r: 0.981581,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1477.54,
    cy: 432.177,
    r: 1.43886,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.183,
    cy: 350.172,
    r: 1.09697,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.398,
    cy: 261.947,
    r: 1.09428,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1234.64,
    cy: 125.244,
    r: 1.42296,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1184.07,
    cy: 677.658,
    r: 1.3588,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.349,
    cy: 454.145,
    r: 1.50727,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.167,
    cy: 425.388,
    r: 1.0767,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1288.96,
    cy: 217.359,
    r: 1.06655,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.123,
    cy: 137.84,
    r: 0.840271,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.144,
    cy: 8.01434,
    r: 1.08551,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.308,
    cy: 453.034,
    r: 1.29632,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1535.84,
    cy: 273.646,
    r: 1.24711,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1431.91,
    cy: 480.635,
    r: 1.45949,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.865,
    cy: 353.16,
    r: 0.872778,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.844,
    cy: 613.282,
    r: 1.34905,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.42,
    cy: 156.326,
    r: 1.05798,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 990.413,
    cy: 230.03,
    r: 1.05916,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1579.53,
    cy: 612.881,
    r: 1.41219,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.808,
    cy: 443.895,
    r: 1.18247,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 812.843,
    cy: 129.018,
    r: 1.32815,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.778,
    cy: 481.398,
    r: 1.24918,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1192.64,
    cy: 15.0217,
    r: 1.34677,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738.594,
    cy: 278.418,
    r: 0.817739,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.08,
    cy: 22.4212,
    r: 1.43881,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.472,
    cy: 670.83,
    r: 1.33147,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.66,
    cy: 560.28,
    r: 1.38263,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.84,
    cy: 537.764,
    r: 1.08506,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.078,
    cy: 282.413,
    r: 1.2298,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.823,
    cy: 174.154,
    r: 1.32156,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.611,
    cy: 278.742,
    r: 0.962464,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1229.49,
    cy: 89.5567,
    r: 1.43587,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1446.59,
    cy: 156.929,
    r: 1.15549,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.11,
    cy: 478.695,
    r: 1.18708,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1360.71,
    cy: 205.556,
    r: 1.41324,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1222.99,
    cy: 332.229,
    r: 1.18751,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.134,
    cy: 557.431,
    r: 1.27387,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 736.466,
    cy: 661.031,
    r: 0.821931,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.963,
    cy: 51.5032,
    r: 1.24785,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.911,
    cy: 303.016,
    r: 0.898213,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.369,
    cy: 672.214,
    r: 0.792109,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.461,
    cy: 63.7277,
    r: 0.942527,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.258,
    cy: 302.953,
    r: 1.12597,
    fill: "#333333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3_2018)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 836.5,
    cy: 362,
    rx: 697.5,
    ry: 171,
    fill: "#836937",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3_2018",
    x: 0.100006,
    y: 52.1,
    width: 1672.8,
    height: 619.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 69.45,
    result: "effect1_foregroundBlur_3_2018"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1513,
    height: 677,
    fill: "white",
    transform: "translate(80)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_2018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1513,
    height: 1513,
    fill: "white",
    transform: "translate(80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfield);
export default __webpack_public_path__ + "static/media/starfield.a6f081e242065193ffdcd6f781179b10.svg";
export { ForwardRef as ReactComponent };